<script>

import EventBus from '../instances/event-bus';
import Note from './note';
import Modal from './modal';
import NoteForm from './note-form';
import Icon from './icon';
import NotesService from '../services/notes';

export default {
  components: {
    Note,
    Modal,
    NoteForm,
    Icon
  },

  data() {
    return {
      cursor: '',
      hasNextPage: false,
      notes: [],
      totalCount: 0,
    };
  },

  props: {
    resourceName: { required: true },
    noteableId: { required: true },
    noteableType: { required: true },
    list: { required: true }
  },

  mounted() {
    const self = this;
    self.addNotes();
    EventBus.$on('addNote', (obj) => {
      if ( self.list === 'personal' && obj.node.status === 'personal' ) {
        self.notes.unshift({node: obj.node});
      }
      else if ( self.list === 'public' && (obj.node.status === 'pending' || obj.node.status === 'approved' ) ) {
        self.notes.unshift({node: obj.node});
      }
    });
  },

  methods: {
    addNotes() {
      const self = this;
      let edges;
      NotesService.get(self.list, self.noteableId, self.noteableType, self.cursor).then(
        response => {
          edges = response.data.notes.edges;
          if (!!edges.length) {
            self.notes = self.notes.concat(edges);
            self.hasNextPage = response.data.notes.pageInfo.hasNextPage;
            self.totalCount = response.data.notes.totalCount;
            self.cursor = edges[edges.length-1].cursor;
          }
        }
      );
    }
  }
}
</script>

<template lang="html">
  <div class="l-wrap--medium">
    <ol v-if="!!notes.length" class="u-mt2">
      <li v-for="(item, index) in notes">
        <note :note="item.node"></note>
      </li>
    </ol>

    <div v-else class="u-richtext u-richtext--scale u-mt4 ">
      <p>There are no notes for {{ resourceName }}.</p>
    </div>

    <button v-if="hasNextPage" @click="addNotes" class="Notes-more u-mt2">
      <icon icon="plus"></icon>
      View more notes
    </button>
  </div>
</template>



// WEBPACK FOOTER //
// note-listing.vue?119fb886